
import {
  getKeysTotal,
  getAllMembers,
  timestampToTime,
  getQueryString,
  formateMonth,
} from '../utils/utils.js';
import Auth from '../utils/auth';
import { schoolWebService }  from '@/utils/webService';
const webService = schoolWebService;

const actions = {
  handleErrorMessage({ commit }, err) {
    commit('handleErrorMessage', err);
  },
  handleSuccessMessage({ commit }, suc) {
    commit('handleSuccessMessage', suc);
  },
  getAllCourse({ commit }, selectMemberType) {
    webService
      .getAllCourse()
      .then(response =>
        commit('setAllCourse', {
          ...response.data,
          list: response.data.list.sort((s, t) => {
            return (
              response.data.actions.find(m => m.courseId === s.id).indexOrder -
              response.data.actions.find(n => n.courseId === t.id).indexOrder
            );
          }),
        })
      )
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  getCourse({ commit }, id) {
    return webService
      .getCourse(id, 'stock')
      .then(response => {
        let data = JSON.parse(response.data.course.multiContent);
        commit('setCourse', {
          ...response.data,
          course: {
            ...response.data.course,
            multiContent: {
              ...data,
              contents:
                data.contents != undefined
                  ? data.contents.sort((s, t) => s.order - t.order)
                  : '',
            },
          },
        });
      })
      .then(() => {
        webService
          .getMineCourse(id)
          .then(response => commit('setMineCourse', response.data));
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  getMyCourse({ commit }) {
    webService.getMyCourse('courses,actions').then(response => {
      	let data = []
      	let time = new Date().getTime() - 7 * 24 * 3600 * 1000;
      	response.data.list.forEach(item => {
      		if(item.status != 'apply') data.push(item)
      		if(item.status == 'apply' && item.createDate > time) data.push(item)
      	});
      	response.data.list = data
      	commit('setMyCourse', response.data)
      }).catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  createCourse({ commit, dispatch }, id) {
    webService
      .createCourse(id, 'wxPublic')
      .then(response => {
        WeixinJSBridge.invoke(
          // eslint-disable-line
          'getBrandWCPayRequest',
          response.data.publicPayBody,
          function(res) {
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              webService.confirmPay(response.data.sitePayOrder);
              location.replace(location);
            } else {
              commit('handleErrorMessage', '支付失败');
            }
          }
        );
      })
      .catch(err => {
        commit('handleErrorMessage', err);
      });
  },
  toLearn({ commit }, id) {
    webService.toLearn(id).then(response => {
      const link = document.createElement('a');
      link.href = response.data.aacesses[0].accessLink;
      link.click();
    });
  },
  //获取站点接口版本信息
  getSchoolSiteVersion({ commit }) {
    webService
      .getSchoolSiteVersion()
      .then(response => commit('setSchoolSiteVersion', response.data.version));
  },
};

export default actions;



// WEBPACK FOOTER //
// ./src/actions/school.js